import { i18n } from '@/lang/i18n';
import { environmentService, getRequestHandler, postRequestHandler } from '@/utils/services';
import { compressToUTF16 as compress, decompressFromUTF16 as decompress }  from 'lz-string';
import { DialogProgrammatic as Dialog } from 'buefy'

const DefaultState = ()=>{
  return {
    apiUrl: null,
    apiUrlRatePlan: null,
    rateplanCreated: false,
    gridUpdate: false,
    updatedData: null,
    searchUpdate: false,
    searchData: null,
    mealPlans: [],
    cancellationTypes: [],
    deletionSuccess:false
  };
},
      state = DefaultState(),
      getters = {
        rateplanCreated: state => state.rateplanCreated,
        gridUpdate: state => state.gridUpdate,
        searchUpdate: state => state.searchUpdate,
        mealPlans: state => state.mealPlans,
        cancellationTypes: state => state.cancellationTypes,
        searchData: state => state.searchData,
        updatedData: state => state.updatedData,
        deletionSuccess: state => state.deletionSuccess
      },
      mutations = {
        setApiUrls(state){
          state.apiUrl = environmentService.apiUrlRatePlan;
          state.apiUrlRatePlan = environmentService.apiUrlRatePlan;
        },
        setCancellationTypes(state, payload){
          state.cancellationTypes = payload;
        },
        setMealPlans(state, payload){
          state.mealPlans = payload;
        },
        setRateplanCreated(state, payload){
          state.rateplanCreated = payload;
        },
        setGridUpdate(state, payload){
          if (payload.status && payload.data) {
            state.updatedData = payload.data;
          } else {
            state.updatedData = null;
          }
          state.gridUpdate = payload;
        },
        setSearchUpdate(state, payload){
          if (payload.status && payload.data) {
            state.searchData = payload.data;
          } else {
            state.searchData = null;
          }
          state.searchUpdate = payload.status;
        },
        setDeletionSuccess(state, payload) {
          state.deletionSuccess = payload;
        }
      },
      actions = {
        setDeletionSuccess({commit}, payload){
          commit('setDeletionSuccess', payload)
        },

        async getRatesCheck({commit, dispatch, state, rootState}, payload){
          i18n.locale = rootState.global.locale;
          if (!state.apiUrlRatePlan) {
            commit('setApiUrls');
          }
          dispatch('global/setToastNotification', {title: i18n.t('lang.store.rateplans.rateplans'), text: i18n.t('lang.store.rateplans.relatedMsg'), type:'success'},{ root: true });
          const rpId = {rateplanId: payload.rateplanId};
          const results =  await postRequestHandler(`${state.apiUrlRatePlan}/rateplans/rates/check`, rpId, { headers: rootState.auth.headers});
          if (results.status == 200) {
            if (results.data.count) {
              Dialog.confirm({
                title: i18n.t('lang.store.rateplans.deletionTitle', [payload.rateplanName]),
                message: `
                <div class="container">
                ${i18n.t('lang.store.rateplans.period', [results.data.start_date, results.data.end_date])}
                <br>
                ${i18n.t('lang.store.rateplans.count', [results.data.count])}
                <br>
                ${i18n.t('lang.store.rateplans.comment', ['<br/>'])}
                </div>
                `,
                confirmText: i18n.t('lang.store.confirm'),
                cancelText: i18n.t('lang.store.cancel'),
                hasIcon: false,
                onConfirm: () => dispatch('deleteRateplan', rpId)
              })
            } else {
              Dialog.confirm({
                title: i18n.t('lang.store.rateplans.deletionTitle', [payload.rateplanName]),
                message: `${i18n.t('lang.store.rateplans.noRates')}`,
                confirmText: i18n.t('lang.store.confirm'),
                cancelText: i18n.t('lang.store.cancel'),
                hasIcon: false,
                onConfirm: () => dispatch('deleteRateplan', rpId)
              })
            }
          }
        },

        async deleteRateplan({commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          const results =  await postRequestHandler(`${state.apiUrlRatePlan}/rateplans/delete`, payload, { headers: rootState.auth.headers});
          if (results.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.rateplans.rateplans'), text: i18n.t('lang.store.rateplans.deleteSuccess'), type:'success'},{ root: true });
            commit('setDeletionSuccess', true);
          } else {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.rateplans.rateplans'), text:results.errors , type:'danger'},{ root: true });
          }
        },
        async getCancellationTypes({ commit, state, rootState }){
          if (!state.apiUrlRatePlan) {
            commit('setApiUrls');
          }
          const results =  await getRequestHandler(`${state.apiUrlRatePlan}/cancellationtypes`, { headers: rootState.auth.headers});
          commit('setCancellationTypes', results);
        },
        async getMealPlans({ commit, state, rootState }){
          if (!state.apiUrlRatePlan) {
            commit('setApiUrls');
          }
          const results =  await getRequestHandler(`${state.apiUrlRatePlan}/mealplans`, { headers: rootState.auth.headers});
          commit('setMealPlans', results);
        },
        async createRatePlan({ commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          if (!state.piUrl) {
            commit('setApiUrls');
          }
          const result = await postRequestHandler(`${state.apiUrl}/rateplans/create`, payload, { headers: rootState.auth.headers});
          if (result.data.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.rateplans.rateplans'), text:i18n.t('lang.store.rateplans.createSuccess'), type:'success'},{ root: true });
            commit('setRateplanCreated', 'success');
          } else {
            let errors = "";
            result.data.errors.forEach(element => {
              errors = errors + "<br>" + element;
            });
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.rateplans.rateplans'), text:errors , type:'danger'},{ root: true });
            commit('setRateplanCreated', 'error');
          }
        },
        async createRatePlanForCocha({ commit, state, dispatch, rootState}, payload){
          i18n.locale = rootState.global.locale;
          if (!state.piUrl) {
            commit('setApiUrls');
          }
          const result = await postRequestHandler(`${state.apiUrl}/rateplans/create/cocha`, payload, { headers: rootState.auth.headers});
          if (result.data.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.rateplans.rateplans'), text:i18n.t('lang.store.rateplans.createSuccess'), type:'success'},{ root: true });
            commit('setRateplanCreated', 'success');
          } else {
            let errors = "";
            result.data.errors.forEach(element => {
              errors = errors + "<br>" + element;
            });
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.rateplans.rateplans'), text:errors , type:'danger'},{ root: true });
            commit('setRateplanCreated', 'error');
          }
        },
        setSearchUpdate({ commit }, payload) {
          commit('setSearchUpdate', payload);
        },
        setGridUpdate({ commit }, payload){
          commit('setGridUpdate', payload);
        },
        setRateplanCreated({ commit }, payload) {
          commit('setRateplanCreated', payload);
        },
        async editRatePlan({ commit, dispatch, rootState }, payload){
          i18n.locale = rootState.global.locale;
          const result = await postRequestHandler(`${state.apiUrl}/rateplans/update`, payload, { headers: rootState.auth.headers });
          if (result.data.status == 200) {
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.rateplans.rateplans'), text:i18n.t('lang.store.rateplans.updateSuccess'), type:'success'}, {root: true});
            commit('setGridUpdate', {status:true, data: result.data.data});
          } else {
            let errors = "";
            result.data.errors.forEach(element => {
              errors = errors + "<br>" + element;
            });
            dispatch('global/setToastNotification', {title: i18n.t('lang.store.rateplans.rateplans'), text:errors, type:'danger'}, {root: true});
            commit('setGridUpdate', {status:true, data: null});
          }
        },
        async searchRatePlan({ commit, dispatch, rootState }, payload){
          if (!state.piUrl) {
            commit('setApiUrls');
          }
          const result = await postRequestHandler(`${state.apiUrl}/rateplans`, payload, { headers: rootState.auth.headers });
          if (result.status == 200) {
            commit('setSearchUpdate', {status:true, data: result});
          } else {
            commit('setSearchUpdate', {status:true, data: null});
          }
        }
      };

export default {
  namespaced:true,
  state,getters,mutations,actions
};



// WEBPACK FOOTER //
// ./src/store/modules/rateplans.js